import * as React from "react";
import { TextField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /patients/{patientId}/exercises (lecture seule depuis le BO).
export default {
  list: subResourceList({
    parentParam: "patientId",
    parentLabel: "ID patient",
    children: [
      <TextField key="title" source="title" label="Exercice" />,
      <TextField key="status" source="status" label="Statut" />,
      <TextField key="proId" source="proId" label="ID pro" />,
      <FrDateField key="assignedAt" source="assignedAt" label="Assigné le" showTime />,
      <FrDateField key="completedAt" source="completedAt" label="Terminé le" showTime />,
    ],
  }),
};
